import styled from "styled-components";

export const StyledSpan = styled.span`
  color: #ff4d4f;
  font-size: 16px;
  line-height: 1.5;
`;
